import CurvedArrowLeft from 'components/shared/curved-arrow-left';
import SiteLink from 'components/shared/sitelink';
import { formatDate, addDaysToDate, checkForReturn } from 'lib/utils/helpers';
import { formatPriceByStoreLocale } from 'lib/shopify';
import OrderItem from './orderItem';
import styles from './orderDetails.module.scss';

const OrderDetails = ({
  customer,
  order,
  orderdetailsaccountpage,
  secondorderdetailsaccountpage,
  ordersReturnNotPossibleContent,
  setOrder,
  setShowDetails,
  locale,
}) => {
  const {
    orderSectionTitle,
    orderNumberContent,
    orderPlacedContent,
    orderTotalContent,
    orderStatusShippedContent,
    shippingDetailsTitleContent,
    orderPaymentDetailsTitleContent,
    orderSummaryTitleContent,
    orderSubtotalContent,
    orderShippingContent,
  } = orderdetailsaccountpage;

  const {
    orderBillingAddressHeaderContent,
    orderTotalFieldContent,
    orderReturnDetailsHeaderContent,
    orderReturnPossibleContent,
    orderRequestReturnButtonContent,
    orderBackToOrdersButtonContent,
    quantityField,
  } = secondorderdetailsaccountpage;

  const returnDate = addDaysToDate(order.processedAt, 14);
  const formatReturnDate = formatDate(returnDate);

  return (
    <>
      <div className={styles.orderContainer}>
        <div className={styles.orderDetails}>
          <h2 className={styles.secondaryTitle}>{orderSectionTitle?.text}</h2>
          <ul>
            <li>
              {orderNumberContent?.text}: {order?.orderNumber}
            </li>
            <li>
              {orderPlacedContent?.text}: {formatDate(order?.processedAt)}
            </li>
            <li>
              {orderTotalContent?.text}:{' '}
              {formatPriceByStoreLocale({
                locale,
                price: order?.totalPrice?.amount,
              })}
            </li>
            {order?.fulfillmentStatus === 'FULFILLED' && <li>{orderStatusShippedContent?.text}</li>}
          </ul>
        </div>
        <div className={styles.shippingDetails}>
          <h2 className={styles.secondaryTitle}>{shippingDetailsTitleContent?.text}</h2>
          <ul>
            <li>
              {customer.firstName} {customer.lastName}
            </li>
            <li>
              {customer.defaultAddress?.address1} {customer.defaultAddress?.address2}
            </li>
            <li>
              {customer.defaultAddress?.zip} {customer.defaultAddress?.city}
            </li>
            <li>{customer.defaultAddress?.country}</li>
          </ul>
        </div>
        <div className={styles.paymentDetails}>
          <h2 className={styles.secondaryTitle}>{orderPaymentDetailsTitleContent?.text}</h2>
          <div className={styles.billingAddress}>
            <h3>{orderBillingAddressHeaderContent?.text}:</h3>
            <ul>
              <li>
                {customer.firstName} {customer.lastName}
              </li>
              <li>
                {customer.defaultAddress?.address1} {customer.defaultAddress?.address2}
              </li>
              <li>
                {customer.defaultAddress?.zip} {customer.defaultAddress?.city}
              </li>
              <li>{customer.defaultAddress?.country}</li>
            </ul>
          </div>
        </div>
        {order?.lineItems?.edges[0].node.variant !== null && (
          <div className={styles.itemsDetails}>
            {order?.lineItems?.edges.map(edge => (
              <OrderItem
                orderItem={edge?.node}
                key={edge?.node}
                quantityField={quantityField}
                locale={locale}
              />
            ))}
          </div>
        )}
        <div className={styles.orderSummary}>
          <h2 className={styles.secondaryTitle}>{orderSummaryTitleContent?.text}</h2>
          <ul>
            <li className={styles.summaryItem}>
              <span>{orderSubtotalContent?.text}</span>
              <span>
                <strong>
                  {formatPriceByStoreLocale({
                    locale,
                    price: Number(order?.subtotalPriceV2?.amount).toFixed(2),
                  })}
                </strong>
              </span>{' '}
            </li>
            <li className={styles.summaryItem}>
              <span>{orderShippingContent?.text}</span>
              <span>
                <strong>
                  {formatPriceByStoreLocale({
                    locale,
                    price: Number(order?.totalShippingPriceV2?.amount).toFixed(2),
                  })}
                </strong>
              </span>{' '}
            </li>
            <li className={styles.summaryItem}>
              <span>{orderTotalFieldContent?.text}</span>
              <span>
                <strong>
                  {formatPriceByStoreLocale({
                    locale,
                    price: order?.totalPrice?.amount,
                  })}
                </strong>
              </span>{' '}
            </li>
          </ul>
        </div>
        <div className={styles.returnDetails}>
          <h2 className={styles.secondaryTitle}>{orderReturnDetailsHeaderContent?.text}</h2>
          {checkForReturn(returnDate) ? (
            <>
              <p>
                {orderReturnPossibleContent?.text} {formatReturnDate}
              </p>
              <SiteLink
                external="https://www.dpd.com/nl/nl/support/veelgestelde-vragen/veelgestelde_vragen/retourneren/hoe-kan-ik-een-pakket-retour-sturen/"
                className={styles.loginButton}
              >
                <button className={styles.requestReturn} type="submit">
                  {orderRequestReturnButtonContent?.text}
                </button>
              </SiteLink>
            </>
          ) : (
            <p>{`${ordersReturnNotPossibleContent?.text}`}</p>
          )}
        </div>
        <div className={styles.backContainer}>
          <button
            type="button"
            onClick={() => {
              setOrder({});
              setShowDetails(false);
            }}
          >
            <CurvedArrowLeft />
            <span className={styles.backContent}>{orderBackToOrdersButtonContent?.text}</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default OrderDetails;
